import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { getFuelData, downloadFuelXls } from "../../modules/fuel";
import { changeSelectedTags } from "../../modules/units";
import { changeTitle } from "./../../modules/navigation";
import FuelView from "./FuelView";
import hasTP from "./../../utilities/unitsFilters";
import { DOMAIN } from "../../utilities/consts";

class Fuel extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isAlertMessageOpen: false,
      alertMessage: ""
    };
  }

  componentDidMount() {
    this.props.changeTitle("Fuel");
    this.props.changeSelectedTags([]);
  }

  fetchFuelData = () => {
    const config = {
      fechaInicial: this.props.startDate.valueOf(),
      fechaFinal: this.props.endDate.valueOf(),
      unidades: this.props.selectedUnits,
      unidadDistancia: this.props.distanceUnit,
      unidadVolumen: this.props.volumeUnit,
      zona: this.props.zone
    };

    if (config.unidades.length === 0) {
      this.openAlertMessage(this.props.lang.SeleccioneAlMenosUnaUnidad);
      return;
    }

    this.props.getFuelData(config).catch(error => {
      this.openAlertMessage(this.props.lang.ErrorAlConsultarDatos);
    });
  };

  openAlertMessage = message => {
    this.setState({
      isAlertMessageOpen: true,
      alertMessage: message
    });
  };

  handleCloseAlertMessage = () => {
    this.setState({
      isAlertMessageOpen: false,
      message: ""
    });
  };

  downloadExcel = () => {
    const fechaInicial = this.props.startDate.valueOf(),
      fechaFinal = this.props.endDate.valueOf(),
      lang = this.props.lang._code === "en" ? "en-US" : "es-MX",
      unidades = this.props.selectedUnits,
      unidadDistancia = this.props.distanceUnit,
      unidadVolumen = this.props.volumeUnit,
      zona = this.props.zone,
      costo = this.props.cost;
    window.open(
      `${DOMAIN}/GenerarReporte.aspx?sTipoReporte=fuel&fInicial=${fechaInicial}&fFinal=${fechaFinal}&aUnidades=${unidades}&zona=${zona}&lang=${lang}&unidadDistancia=${unidadDistancia}&unidadVolumen=${unidadVolumen}&costo=${costo}`,
      "_blank"
    );
  };

  downloadPDF = () => {
    const fechaInicial = this.props.startDate.valueOf(),
      fechaFinal = this.props.endDate.valueOf(),
      lang = this.props.lang._code === "en" ? "en-US" : "es-MX",
      unidades = this.props.selectedUnits,
      unidadDistancia = this.props.distanceUnit,
      unidadVolumen = this.props.volumeUnit,
      zona = this.props.zone,
      costo = this.props.cost;

    window.open(
      `${DOMAIN}/GenerarReporte.aspx?sTipoReporte=fuelPDF&fInicial=${fechaInicial}&fFinal=${fechaFinal}&aUnidades=${unidades}&zona=${zona}&lang=${lang}&unidadDistancia=${unidadDistancia}&unidadVolumen=${unidadVolumen}&costo=${costo}`,
      "_blank"
    );
  };

  render() {
    return (
      <FuelView
        fetchFuelData={this.fetchFuelData}
        downloadExcel={this.downloadExcel}
        downloadPDF={this.downloadPDF}
        alertMessage={this.state.alertMessage}
        isAlertMessageOpen={this.state.isAlertMessageOpen}
        handleCloseAlertMessage={this.handleCloseAlertMessage}
        {...this.props}
      />
    );
  }
}

const mapStateToProps = state => {
  let lang = state.internationalization.lang;
  let distanceUnit = state.fuel.data.UnidadVelocidad;
  let performance = [];
  let events = [];
  let behavior = {};
  let initialFuel = [];
  let finalFuel = [];
  let charges = [];
  let discharges = [];
  let iddleFuel = [];
  let consumedFuel = [];
  let summaryBehavior = [];
  let individualReportUnit = "";
  let units = state.units.data.filter(v => hasTP(v, [".gas"]));
  let isIndividualReport = state.fuel.data.Unidades.length <= 1;
  let maxVolume = 1000;
  let isStationary = false;
  let isNoConsume = false;
  let unitType = "";

  const selectedTags = state.units.selectedTags;
  if (selectedTags.length > 0)
    units = units.filter(unit => {
      let unitTags = unit.Etiquetas.split(",").filter(t => t !== "");
      return (
        unitTags.filter(ut => {
          return selectedTags.includes(ut);
        }).length > 0
      );
    });

  let thereAreNoRegularUnits =
    !state.fuel.data.Unidades.map(
      u => units.filter(v => v.Unidad === u)[0]
    ).filter(u => !hasTP(u, ["estacionario"]) && !hasTP(u, ["noconsume"]))
      .length > 0;

  let thereAreOnlyRegularUnits =
    state.fuel.data.Unidades.map(
      u => units.filter(v => v.Unidad === u)[0]
    ).filter(u => !hasTP(u, ["estacionario"]) && !hasTP(u, ["noconsume"]))
      .length === state.fuel.data.Unidades.length;

  if (state.fuel.hasData) {
    if (isIndividualReport) {
      isStationary =
        units.filter(
          u =>
            hasTP(u, [".estacionario"]) &&
            u.Unidad === state.fuel.data.Unidades[0]
        ).length === 1;

      isNoConsume =
        units.filter(
          u =>
            hasTP(u, [".noconsume"]) && u.Unidad === state.fuel.data.Unidades[0]
        ).length === 1;

      if (isStationary) unitType = lang.UnidadEstacionaria;
      else if (isNoConsume) unitType = lang.UnidadDeNoConsumo;
    }

    individualReportUnit = units.filter(
      u => state.fuel.data.Unidades[0] === u.Unidad
    )[0];

    maxVolume = state.fuel.data.VolumenesMaximos.filter(
      v => v.Unidad === state.fuel.data.Unidades[0]
    )[0].Volumen;

    performance = [
      {
        Concepto: lang.ReporteInicial,
        ...state.fuel.data.ReporteGeneral.ReporteInicial,
        Costo:
          state.fuel.cost *
          state.fuel.data.ReporteGeneral.ReporteInicial.Volumen
      },
      {
        Concepto: lang.CargasCombustible,
        ...state.fuel.data.ReporteGeneral.Cargas,
        Costo: state.fuel.cost * state.fuel.data.ReporteGeneral.Cargas.Volumen
      },
      {
        Concepto: lang.DescargasCombustible,
        ...state.fuel.data.ReporteGeneral.Descargas,
        Costo:
          state.fuel.cost * state.fuel.data.ReporteGeneral.Descargas.Volumen
      },
      {
        Concepto: lang.Ralenti,
        ...state.fuel.data.ReporteGeneral.Ralenti,
        Valor:
          isIndividualReport && thereAreNoRegularUnits
            ? "N/A"
            : `${state.fuel.data.ReporteGeneral.Ralenti.Valor}`,
        Volumen:
          isIndividualReport && thereAreNoRegularUnits
            ? "N/A"
            : `${state.fuel.data.ReporteGeneral.Ralenti.Volumen}`,
        Costo:
          isIndividualReport && thereAreNoRegularUnits
            ? 0
            : state.fuel.cost * state.fuel.data.ReporteGeneral.Ralenti.Volumen
      },
      {
        Concepto: thereAreNoRegularUnits
          ? lang.Desviacion
          : thereAreOnlyRegularUnits
          ? lang.Consumo
          : `${lang.Consumo} / ${lang.Desviacion}`,
        ...state.fuel.data.ReporteGeneral.Consumido,

        Volumen:
          isIndividualReport && thereAreNoRegularUnits
            ? state.fuel.data.ReporteGeneral.Consumido.Volumen +
              state.fuel.data.ReporteGeneral.Ralenti.Volumen
            : state.fuel.data.ReporteGeneral.Consumido.Volumen,
        Valor:
          isIndividualReport && thereAreNoRegularUnits
            ? "N/A"
            : `${
                state.fuel.data.ReporteGeneral.Consumido.Valor
              } ${distanceUnit}`,
        Costo:
          state.fuel.cost * state.fuel.data.ReporteGeneral.Consumido.Volumen
      },
      {
        Concepto: lang.ReporteFinal,
        ...state.fuel.data.ReporteGeneral.ReporteFinal,

        Costo:
          state.fuel.cost * state.fuel.data.ReporteGeneral.ReporteFinal.Volumen
      }
    ];

    events = state.fuel.data.Eventos.map(e => ({
      ImagenUrl: `https://apps.zeekgps.com/alpha/images/${e.Evento}.svg`,
      Costo: e.MagnitudEvento * state.fuel.cost,
      Fecha: e.Fecha,
      Volumen: e.MagnitudEvento,
      Direccion: "",
      Ciudad: "",
      Mapa: e.Mapa,
      Latitud: e.Latitud,
      Longitud: e.Longitud
    }));

    behavior = state.fuel.data.ReporteGeneral.ComportamientoGeneral;

    initialFuel = state.fuel.data.CombustibleInicial.map(t => ({
      ...t,
      Unidad: state.units.data.filter(u => t.Unidad === u.Unidad)[0]
        .Descripcion,
      Costo: state.fuel.cost * t.Volumen
    }));
    finalFuel = state.fuel.data.CombustibleFinal.map(t => ({
      ...t,
      Unidad: state.units.data.filter(u => t.Unidad === u.Unidad)[0]
        .Descripcion,
      Costo: state.fuel.cost * t.Volumen
    }));
    charges = state.fuel.data.CargasCombustible.map(t => ({
      ...t,
      Unidad: state.units.data.filter(u => t.Unidad === u.Unidad)[0]
        .Descripcion,
      Costo: state.fuel.cost * t.Volumen
    }));
    discharges = state.fuel.data.DescargasCombustible.map(t => ({
      ...t,
      Unidad: state.units.data.filter(u => t.Unidad === u.Unidad)[0]
        .Descripcion,
      Costo: state.fuel.cost * t.Volumen
    }));
    iddleFuel = state.fuel.data.RalentiCombustible.map(t => {
      let unit = state.units.data.filter(u => t.Unidad === u.Unidad)[0];
      let isStationaryUnit = hasTP(unit, [".estacionario"]);
      let isNoConsumeUnit = hasTP(unit, [".noconsume"]);

      if (isStationaryUnit || isNoConsumeUnit)
        return {
          Unidad: unit.Descripcion,
          Valor: "N/A",
          Volumen: "N/A",
          Costo: 0
        };
      return {
        ...t,
        Unidad: unit.Descripcion,
        Costo: state.fuel.cost * t.Volumen
      };
    });
    consumedFuel = state.fuel.data.CombustibleConsumido.map(t => {
      let unit = state.units.data.filter(u => t.Unidad === u.Unidad)[0];
      let isStationaryUnit = hasTP(unit, [".estacionario"]);
      let isNoConsumeUnit = hasTP(unit, [".noconsume"]);

      if (isStationary)
        return {
          ...t,
          Unidad: unit.Descripcion,
          Valor: "N/A"
        };
      return {
        ...t,
        Unidad: unit.Descripcion,
        Costo: state.fuel.cost * t.Volumen
      };
    });

    summaryBehavior = state.fuel.data.ResumenComportamiento.map(t => {
      let unit = state.units.data.filter(u => t.Unidad === u.Unidad)[0];
      let isStationaryUnit = hasTP(unit, [".estacionario"]);
      let isNoConsumeUnit = hasTP(unit, [".noconsume"]);

      if (isStationaryUnit)
        return {
          Unidad: unit.Descripcion,
          Tipo: lang.UnidadEstacionaria,
          VelocidadMaxima: "N/A",
          TiempoMovimiento: "N/A",
          TiempoMuerto: "N/A",
          RendimientoBruto: "N/A",
          RendimientoEfectivo: "N/A"
        };
      else if (isNoConsumeUnit)
        return {
          ...t,
          Unidad: unit.Descripcion,
          Tipo: lang.UnidadDeNoConsumo,
          RendimientoBruto: "N/A",
          RendimientoEfectivo: "N/A"
        };
      return {
        ...t,
        Unidad: unit.Descripcion,
        Tipo: lang.UnidadRegularDeConsumo,
        Costo: state.fuel.cost * t.Volumen
      };
    });
  }

  return {
    lang,
    history: state.fuel.data.Ubicaciones,
    data: state.fuel.data,
    isLoading: state.fuel.isLoading,
    hasData: state.fuel.hasData,
    distanceUnit,
    volumeUnit: state.fuel.data.UnidadVolumen,
    units,
    unitType,
    selectedUnits: state.units.selectedUnits,
    startDate: state.dates.startDate,
    endDate: state.dates.endDate,
    zone: state.dates.zone,
    permissions: state.permissions.data,
    loadedPermissions: state.permissions.loadedPermissions,
    isIndividualReport, //state.fuel.data.Unidades.length <= 1, // prueba
    individualReportUnit,
    cost: state.fuel.cost,
    currency: state.fuel.currency,
    behavior,
    performance,
    events,
    initialFuel,
    finalFuel,
    charges,
    discharges,
    iddleFuel,
    consumedFuel,
    summaryBehavior,
    maxVolume,
    isStationary,
    isNoConsume,
    thereAreNoRegularUnits,
    thereAreOnlyRegularUnits,
    firstLocationDate: state.fuel.data.FechaPrimeraUbicacion,
    lastLocationDate: state.fuel.data.FechaUltimaUbicacion
  };
};

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      getFuelData,
      downloadFuelXls,
      changeTitle,
      changeSelectedTags
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Fuel);



// WEBPACK FOOTER //
// ./src/containers/Fuel/Fuel.js